import { createSlice } from '@reduxjs/toolkit';

import themesFromStore from 'GeminiViewerComponent/theme/defaultThemes';
import { isEmpty } from 'GeminiViewerComponent/helpers/lodashUtils';

const initialState = {
    activeTheme: 'default',
    userThemes: {},
    defaultAssetTheme: 'default',
    assetThemes: {},
    loadingSvgUri: '',
    loadingSvgCssAnimate: false,
};

const updatedTheme = (defaultTheme, selectedTheme) => {
    let update = { ...defaultTheme, ...selectedTheme };
    (Object.keys(update) || []).forEach((keyName) => {
        if (typeof update[keyName] === 'object' && update[keyName] !== null && !Array.isArray(update[keyName])) {
            update[keyName] = updatedTheme(defaultTheme[keyName], update[keyName]);
        }
    });
    return update;
};

const themesMissingPropertyAddition = (themes) => {
    Object.keys(themes || {}).forEach((themeName) => {
        themes = {
            ...themes,
            [themeName]: updatedTheme(themesFromStore['default'], themes[themeName]),
        };
    });
    return themes;
};

const themeSlice = createSlice({
    name: 'theme',
    initialState,
    reducers: {
        setActiveTheme: (state, action) => {
            state.activeTheme = action.payload;
        },
        setUserThemes: (state, action) => {
            state.userThemes = themesMissingPropertyAddition(action.payload);
        },
        setAssetThemes: (state, action) => {
            state.assetThemes = themesMissingPropertyAddition(action.payload);
        },
        setDefaultAssetTheme: (state, action) => {
            state.defaultAssetTheme = action.payload;
        },
        setLoadingSvg: (state, action) => {
            state.loadingSvgUri = action?.payload?.loadingSvgUri ?? '';
            state.loadingSvgCssAnimate = action?.payload?.loadingSvgCssAnimate ?? true;
        },
        resetThemeToAssetDefaults: (state, action) => {
            state.userThemes = state.assetThemes;
            state.activeTheme = state.defaultAssetTheme;
        },
    },
    extraReducers: (builder) => {},
});

export const selectActiveThemeName = (state) => state.theme.activeTheme;
export const selectActiveTheme = (state) => {
    const allThemes = {
        ...themesFromStore,
        ...state.theme.userThemes,
    };
    return allThemes[state.theme.activeTheme.toLowerCase()];
};
export const selectAllThemes = (state) => ({
    ...themesFromStore,
    ...state.theme.userThemes,
});
export const selectUserThemesLoaded = (state) => !isEmpty(state.theme.userThemes);

export const {
    setActiveTheme,
    setUserThemes,
    setAssetThemes,
    setDefaultAssetTheme,
    setLoadingSvg,
    resetThemeToAssetDefaults,
} = themeSlice.actions;

export const selectDefaultTheme = (state) => {
    const defaultTheme = {
        ...themesFromStore,
    };
    return defaultTheme.default;
};

export const selectLoadingSvg = (state) => ({
    loadingSvgUri: state.theme.loadingSvgUri,
    loadingSvgCssAnimate: state.theme.loadingSvgCssAnimate,
});
export default themeSlice.reducer;
